<template>
    <div class="setup">
        
        <VHeader :page="'Setup'"></VHeader>
        <div class="setup-table highlighted-table">
            <div class="setup-table-header">
                <template v-if="!isLoading">
                    <div class="setup-table-header-title">
                        Logo
                    </div>
                    <div class="setup-table-header-title">
                        App id
                    </div>
                    <div class="setup-table-header-title ">
                        Bundle id
                    </div>
                </template>
                <template v-else>
                    <VLoadingRow></VLoadingRow>
                </template>
            </div>
            <template v-if="!isLoading">
                <div
                    class="setup-table-row "
                    v-for="(setup) in setups"
                    :key="setup.name"
                >
                    <div
                        class="setup-table-row-shell"
                        @click="openSetup(setup)"
                    >
                        <div class="setup-table-row-shell__img">
                            <img
                                :src="setup.logo_small"
                                alt=""
                            >
                        </div>
                        <div class="setup-table-row-shell-text">
                            {{ setup.app_id }}
                        </div>
                        <div class="setup-table-row-shell-text ">
                            {{ setup.bundle_id }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div
                    class="setup-table-row "
                    v-for="(number) in expectedAppsAmount"
                    :key="number"
                >
                    <VLoadingRow height="44px"></VLoadingRow>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import VLoadingRow from '../../components/VLoadingRow';
    import {getProjects} from '../../api/apiServices';
    
    export default {
        name: 'Apps',
        components: {
            VLoadingRow,
        },
        data() {
            return {
                expectedAppsAmount: getProjects().length,
            };
        },
        props: {
            setups: {
                type: Array,
                required: true,
            },
            isLoading: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            openSetup(setup) {
                this.$router.push(`/setup/${setup.app_id}`);
            },
        },
    };
</script>

<style
    lang="scss"
    scoped
>
    .setup {
        &-table {
            
            border-radius: 10px;
            @include dark-shadow;
            max-width: 567px;
            margin: 26px 26px 26px 26px;
            
            &-header {
                display: flex;
                height: 45px;
                border-bottom: 1px solid #6089E7;
                
                .VLoadingRow {
                    border-radius: 10px 10px 0 0;
                }
                
                @media (max-width: 927px) {
                    padding-left: 5px;
                    padding-right: 20%;
                }
                
                &-title {
                    text-align: center;
                    margin-top: 23px;
                    font-family: Poppins;
                    height: 12px;
                    color: #000F48;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 12px;
                    width: 180px;
                    
                }
                
                &-title__long {
                    width: 27px;
                }
            }
            
            &-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                min-height: 45px;
                border-top: 1px solid rgba(96, 137, 231, 0.2);
                @media (max-width: 927px) {
                    padding-left: 5px;
                    padding-right: 2%;
                }
                
                &-shell {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    
                    &-text {
                        font-family: Quicksand;
                        color: #000F48;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 18px;
                        width: 180px;
                        text-align: center;
                        @media (max-width: 927px) {
                            font-size: 12px;
                        }
                    }
                    
                    &__img {
                        width: 180px;
                        
                        img {
                            width: 40px;
                            height: 40px;
                            background-size: contain;
                            background-repeat: no-repeat;
                        }
                    }
                    
                    &-scheme {
                        display: flex;
                        flex-direction: column;
                        width: 180px;
                        
                        &-text {
                            display: flex;
                            flex-direction: column;
                        }
                    }
                }
            }
        }
        
        &-table__scheme {
            max-width: 387px;
        }
    }
</style>